import type { Categoria } from '../core/api/types'
import type { UseI18n } from '../core/i18n/useI18n'
import i18n from '../core/i18n/i18n'

/** Categorias operacionais têm código estável; o rótulo da API é fallback. */
export function categoryLabel(
  category: Pick<Categoria, 'code' | 'label'> | null | undefined,
  t: UseI18n['t'],
): string {
  if (!category) return ''
  const key = `category.${category.code}`
  const translated = t(key)
  return translated === key ? category.label : translated
}

/** Variante para loaders/Mapbox fora da árvore React. */
export function currentCategoryLabel(
  category: Pick<Categoria, 'code' | 'label'> | null | undefined,
): string {
  if (!category) return ''
  const key = `category.${category.code}`
  const translated = String(i18n.t(key))
  return translated === key ? category.label : translated
}
